import React, { Component, Fragment } from 'react'
import axios from "axios";

import { connect } from 'react-redux'
import { NavLink, withRouter } from 'react-router-dom';

import DashboardRecentCards from './DashboardRecentCards/DashboardRecentCards'
import DashboardFavoritesCards from './DashboardFavoritesCards/DashboardFavoritesCards'
import DashboardViewsCards from './DashboardViewsCards/DashboardViewsCards'


import moment from 'moment';

class Dashboard extends Component {
    _isMounted = false;
    state = {
        now :  moment()
    }

    componentDidMount(){
        this._isMounted = true;
        this.refresh = setInterval(()=>{
            if (this._isMounted) {
                this.setState({
                    now :  moment()
                })
            }
        }, 3000);
    }

    componentWillUnmount() {
        this._isMounted = false;
      }

    render() {
        const expirationdate = moment.unix(this.props.expiration);
        const expirationdatebefore = moment.unix(this.props.expiration).subtract(7, 'days');
        const displaybanner = (expirationdatebefore < this.state.now && this.props.location.pathname!='/account/');
        const accountdisabled = expirationdate<=this.state.now;
        if(accountdisabled){
            return(<div><h1>Your subscription</h1><p><strong>{this.props.termes.application.membreBannerTextHasExpired} {expirationdate.fromNow() }</strong></p><NavLink  style={{marginBottom : "80px"}} className="buttonbig"  to="/account/">{this.props.termes.application.membreBannerBTNHasExpired}</NavLink></div>)
        }
        return(
            <div>
            { displaybanner ? <div><h1>Your subscription</h1><p><strong>Your subscription will expire {expirationdate.fromNow() }</strong></p><NavLink  style={{marginBottom : "80px"}} className="buttonbig"  to="/account/">upgrade your account</NavLink></div>: null }
            <h1 style={{marginTop:40}}>{ this.props.termes.application.membreDashboardAdded}</h1>
            <DashboardRecentCards />
            <h1>{ this.props.termes.application.membreDashboardViewed}</h1>
            <DashboardViewsCards />
            <h1>{ this.props.termes.application.membreDashboardFavorites}</h1>
            <DashboardFavoritesCards />
            </div>
        );
    }
}

const mapStateToProps = (state)=>{
    return {
      expiration:state.auth.userinfos.expirationtimestamp,
      termes: state.settings.termes
    }
  };
  
  
export default connect(mapStateToProps)(withRouter(Dashboard));